export default class Preload {
  init() {
    setTimeout(function () {
      document.body.classList.remove("preload");
    }, 500);
  }
}
